import { useEvent, useKeyPressEvent } from 'react-use';
import { deviceProperties } from '@/lib/deviceProperties';

export const useEnterOrSpace = (onPressHandler: () => void, onReleaseHandler?: () => void): void => {
    useKeyPressEvent('Enter', onPressHandler, onReleaseHandler);
    useKeyPressEvent(' ', onPressHandler, onReleaseHandler);
};

export const useEnterSpaceOrClick = (onPressHandler: () => void, onReleaseHandler?: () => void): void => {
    const { isTouchDevice } = deviceProperties();
    useEnterOrSpace(onPressHandler, onReleaseHandler);
    useEvent('touchstart', isTouchDevice ? onPressHandler : null);
    useEvent('touchend', isTouchDevice ? onReleaseHandler : null);
    useEvent('mousedown', isTouchDevice ? null : onPressHandler);
    useEvent('mouseup', isTouchDevice ? null : onReleaseHandler);
};
